// Background Images Mapping System
// Maps friendly names to actual image imports for use with bg prop

import bg from '../Assets/img/bg.webp';
import bgr from '../Assets/img/bgr.webp';
import black__bgr from '../Assets/img/black_bgr.webp';

/**
 * Background images mapping object
 * Use these keys as values for the `bg` prop in components
 *
 * @example
 * <Header bg="bg" />
 * <OurTeam bg="main" />
 * <WorkerOffer bg="v5" />
 * <Partners bg="image10" />
 */
export const backgroundImages = {
  // Main backgrounds
  bg,
  bgr,
  black__bgr,
};

/**
 * Get background image by name
 *
 * @param {string} bgName - Name of the background image
 * @returns {string|null} - Image URL or null if not found
 *
 * @example
 * const bgImage = getBackgroundImage('main');
 * // Returns the imported main.webp image
 */
export const getBackgroundImage = (bgName) => {
  if (!bgName) return null;
  return backgroundImages[bgName] || null;
};

/**
 * Get list of all available background names
 *
 * @returns {string[]} - Array of all available background names
 *
 * @example
 * const availableBackgrounds = getAvailableBackgrounds();
 * // Returns: ['bg', 'main', 'v1', 'v2', ..., 'image1', 'image2', ...]
 */
export const getAvailableBackgrounds = () => {
  return Object.keys(backgroundImages);
};
